import { useEffect, useState } from "react";
import { fxSettings, onTierChange, renderTier, watchFrames } from "../utils/renderTier";

// Geeft de huidige kwaliteitstrap en wat daarop aan staat, en tekent opnieuw
// als de trap zakt. Zonder dit blijft bijvoorbeeld de gloed om de meter staan
// tot het scherm herlaadt, en dat is precies het onderdeel dat we op een
// trage Pi juist uit willen kunnen zetten.
export function useRenderTier() {
  const [tier, setTier] = useState(renderTier);

  useEffect(() => onTierChange(setTier), []);

  return { tier, fx: fxSettings() };
}

// Meet één keer hoe vloeiend het beeld loopt zodra het dashboard staat.
// Blijkt het te traag, dan zakt de trap en tekent alles wat hierboven aan
// useRenderTier hangt zichzelf lichter opnieuw.
export function useFrameWatch(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    return watchFrames();
  }, [enabled]);
}
